import styled from 'styled-components'
import {colors} from '../../../../styles/theme'

export const CardBox = styled.div`
  background: #fff;
  border: 1px solid #ebeffc;
  border-radius: 2px;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
`

export const ReportLinkBox = styled.span`
  font-size: 12px;
  color: ${colors.blue1};
  margin-left: auto;
  cursor: pointer;
`

export const CardText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.bksGray70};
  font-weight: 700;
  padding-right: 16px;

  && span {
    font-size: 12px;
    color: ${colors.bksGray70};
    font-weight: 400;
  }
`

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const IconBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  font-size: 12px;
  color: ${colors.bksGray70};
  align-items: center;
  cursor: pointer;
`

export const SpacingBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
`
